import React from 'react'

export default ({ width, height }) => (
  <svg width={width || '25px'} height={height || '25px'} viewBox="0 0 25 25">
    <g
      id="Desktop-og-mobile"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="D_20.02.-Vejledning-ny-foldet-ud"
        transform="translate(-249.000000, -1275.000000)"
        stroke="#454545"
      >
        <g id="Group-6-Copy" transform="translate(250.000000, 1276.000000)">
          <g id="icon/print_plakat">
            <g>
              <path
                d="M19.7027972,20.6206897 L19.7027972,1.97562069 C19.7027972,0.884468966 18.8093357,0 17.7071049,0 L5.21247552,0 C4.11024476,0 3.21678322,0.884468966 3.21678322,1.97562069 L3.21678322,20.6206897"
                id="Stroke-1"
              />
              <polyline
                id="Stroke-3"
                points="22.9195804 16.6023041 22.9195804 22.9999524 0 22.9999524 0 16.6023041"
              />
              <path d="M5.58916084,11.96 L14.1136364,11.96" id="Stroke-5" />
              <path d="M5.58916084,9.2 L17.3304196,9.2" id="Stroke-7" />
              <path d="M5.58916084,5.52 L17.3304196,5.52" id="Stroke-9" />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)



// WEBPACK FOOTER //
// ./src/icons/printIcon.js